import $ from 'jquery';

//Add class to HTML element for dev and localhost

if (window.location.href.indexOf('?cmx=') > 0) {

    var loc = window.location.href; // returns the full URL
    if(/localhost/.test(loc)) {
    $('html').addClass('msg loc');
    }
    if(/438dev.co.uk/.test(loc)) {
    $('html').addClass('msg dev');
    }
    if(/dev.wpengine/.test(loc)) {
    $('html').addClass('msg wpe');
    }

    $('section.stripe').append( '<ul class="toggle-styles"><li class="toggle" id="style-a">A</li><li class="toggle" id="style-b">B</li><li class="toggle" id="style-c">C</li><li class="toggle" id="style-d">D</li><li class="toggle" id="style-e">E</li><li class="toggle" id="style-f">F</li><li class="toggle" id="style-g">G</li><li class="toggle" id="style-h">H</li><li class="clear">X</li></ul>' );

    $('section.stripe.style-a').find('#style-a').addClass('on');
    $('section.stripe.style-b').find('#style-b').addClass('on');
    $('section.stripe.style-c').find('#style-c').addClass('on');
    $('section.stripe.style-d').find('#style-d').addClass('on');
    $('section.stripe.style-e').find('#style-e').addClass('on');
    $('section.stripe.style-f').find('#style-f').addClass('on');
    $('section.stripe.style-g').find('#style-g').addClass('on');
    $('section.stripe.style-h').find('#style-h').addClass('on');


    $("ul.toggle-styles li.toggle").click(function(e) {

        var id= $(e.target).attr('id');
        $(this).parent().parent().removeClass('style-a');
        $(this).parent().parent().removeClass('style-b');
        $(this).parent().parent().removeClass('style-c');
        $(this).parent().parent().removeClass('style-d');
        $(this).parent().parent().removeClass('style-e');
        $(this).parent().parent().removeClass('style-f');
        $(this).parent().parent().removeClass('style-g');
        $(this).parent().parent().removeClass('style-h');
        $(this).parent().parent().addClass(id);
        $('ul.toggle-styles li.toggle').removeClass('on');
        $(this).addClass('on');

    });

    $("ul.toggle-styles li.clear").click(function(e) {
        $("ul.toggle-styles").hide();
    });

}